import * as React from 'react'
import { connect } from 'react-redux'
import { IDetailPageState } from '../../reducers'
import { simpleSelectors } from '../../selectors/basicState'
import { showExploreTabSelector } from '../../selectors/exploreTab'
import { PlaybackContentLink } from '@shared/player'
import { COUNTER_PACKAGE_PREFIX } from '../../utils/utils'
import { withLogger, ILogger } from '../../context/withLogger'
import { PlayerContext } from '@shared/player/integration/playbackArea'
import { buildDetailPageUrl, buildSignInUrl } from '../../utils/url'
import { sanitizedRequestContextSelector } from '../../selectors/requestContext'

type Props = ReturnType<typeof mapStateToProps> & ILogger

const STARLIGHT_PLAY_EVENT = 'StarlightPlayRequest'

export const ConnectedExploreTab = ({ content, showExploreTab, requestContext, titleId, logger }: Props) => {
  const { onPlay } = React.useContext(PlayerContext)
  const { isRecognizedCustomer, queryParameters, originalURI, isRetail } = requestContext

  const getSignInUrl = () => {
    const refMarker = 'dv_dp_explore_sign_in'
    const dpUrl = buildDetailPageUrl({ parameters: queryParameters, originalURI, isRetail }, titleId, refMarker)
    return buildSignInUrl({ parameters: queryParameters, originalURI, isRetail }, refMarker, dpUrl)
  }

  React.useEffect(() => {
    //Short term hack to enable playback from Starlight Content
    if (showExploreTab && content) {
      const eventHandler = ({ detail }: CustomEvent<PlaybackContentLink>) => {
        if (detail) {
          logger.count(`${COUNTER_PACKAGE_PREFIX}_Starlight_Playback`, 1, true)
          onPlay(Object.assign(detail, !isRecognizedCustomer && { signInUrl: getSignInUrl() }))
        }
      }
      document.addEventListener(STARLIGHT_PLAY_EVENT, eventHandler);
      return () => {
        document.removeEventListener(STARLIGHT_PLAY_EVENT, eventHandler);
      }
    }
  }, []);


  if (!showExploreTab || !content) {
    return  null
  }

  return <div dangerouslySetInnerHTML={{__html: content.staticPageContent}}/>
}

const mapStateToProps = (state: IDetailPageState) => ({
  content: simpleSelectors.exploreTabContent(state),
  showExploreTab: showExploreTabSelector(state),
  requestContext: sanitizedRequestContextSelector(state),
  titleId: simpleSelectors.pageTitleId(state)
})

export const ExploreTab = withLogger(connect(mapStateToProps)(
  React.memo(ConnectedExploreTab))
)


